export enum AbsenceType {
  VACATION = 'VACATION',
  HOSPITALIZATION = 'HOSPITALIZATION',
}
